// frontend/src/components/subscription/FeatureGate.js
import React from 'react';
import { useFeatureAccess } from '../../contexts/SubscriptionContext';
import UpgradePrompt from './UpgradePrompt';

const FeatureGate = ({ feature, children, fallback, showLock = true }) => {
  const { hasAccess } = useFeatureAccess(feature);

  if (hasAccess) return <>{children}</>;
  if (fallback) return <>{fallback}</>;
  if (showLock) return <UpgradePrompt feature={feature} />;
  return null;
};

export default FeatureGate;
